/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import { format } from 'date-fns';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from '../../../../setup';
import { ScrollComponent } from '../../../../_start/assets/ts/components';
import {
  getConfig,
  IThemeConfig,
  useTheme,
} from '../../../../_start/layout/core';
import { WEB_URL } from '../../../support/api';
import {
  failureToast,
  handleGenerateSitemap,
  successToast,
} from '../../../support/utils';
import { getAllCustomer } from '../../customer-management/redux/CustomerCRUD';
import { ElementDropContainer } from '../../edit-content/elements/ElementDropContainer';
import {
  setAllCaseDetails,
  setAllCustomers,
  setAllEmployees,
  setAllPosts,
  // setAllPosts,
  setContent,
  setFeaturedCaseDetails,
  setPage,
} from '../../edit-content/redux/EditContentActions';
import { getAllEmployee } from '../../employee-management/redux/EmployeeCRUD';
import { getAllPost } from '../../post-management/redux/PostsCRUD';
import { PageStatusType } from '../models/Page';
import { getAllCaseDetail } from '../redux/CaseDetailCRUD';
import {
  publishPage,
  updatePage,
  UpdatePagePayload,
  viewPage,
} from '../redux/PageCRUD';

const defaultPageConfig = getConfig();
const pageConfig: Partial<IThemeConfig> = {
  sidebar: {
    ...defaultPageConfig.sidebar,
    display: true,
    content: 'edit-content',
    bgColor: 'bg-white',
  },
};

export const PageEditContent = () => {
  const { id } = useParams<{ id: string }>();

  const dispatch = useDispatch();

  const page = useSelector((state: RootState) => state.editContent.page);

  const parentPage = page.parent;

  const content = useSelector((state: RootState) => state.editContent.content);

  const [loading, setLoading] = useState(false);

  const featuredCaseDetails = useSelector(
    (state: RootState) => state.editContent.featuredCaseDetails
  );

  // SUBMIT
  const handleSave = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    setLoading(true);

    const publish_date = format(
      new Date(page.publish_date),
      'yyyy-MM-dd HH:mm:ss'
    );

    try {
      const payload: UpdatePagePayload = {
        ...page,
        content: content,
        publish_date,
        // @ts-ignore
        page_featured_posts: page.page_featured_posts.map((post) => post.id),
        // @ts-ignore
        page_featured_case_details: featuredCaseDetails.map(
          (detail) => detail.id
        ),
      };

      await updatePage(payload);
      successToast('Content has been updated.');
      setLoading(false);
    } catch (error) {
      failureToast(error);
      setLoading(false);
    }
  };

  // INITIALIZATION
  const handleFetch = async (id: string) => {
    setLoading(true);

    try {
      dispatch(setContent([]));

      const [page, allPosts, allCaseDetails, allEmployees, allCustomers] =
        await Promise.all([
          viewPage(id),
          getAllPost(),
          getAllCaseDetail(),
          getAllEmployee(),
          getAllCustomer(),
        ]);

      // set ALL POST data
      dispatch(setAllPosts(allPosts));

      // set ALL CASE DETAIL data
      dispatch(setAllCaseDetails(allCaseDetails));

      // set ALL EMPLOYEE data
      dispatch(setAllEmployees(allEmployees));

      // set ALL CUSTOMER data
      dispatch(setAllCustomers(allCustomers));

      dispatch(setFeaturedCaseDetails(page.page_featured_case_details));

      dispatch(setPage(page)); // set Page data
      dispatch(setContent(page.content)); // set CONTENT data

      setLoading(false);
    } catch (error) {
      failureToast(error);
      setLoading(false);
    }
  };

  const { setTheme } = useTheme();
  // Refresh UI after config updates
  useEffect(() => {
    setTheme(pageConfig);
    setTimeout(() => {
      ScrollComponent.reinitialization();
    }, 100);

    if (id) {
      handleFetch(id);
    }

    return () => {
      setTheme(defaultPageConfig);
    };
  }, [id]);

  const handlePublish = async () => {
    setLoading(true);

    try {
      const result = await publishPage(page);
      dispatch(setPage(result));
      successToast('Page has been published.');
      setLoading(false);
    } catch (error) {
      failureToast(error);
      setLoading(false);
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        {/* begin::Page Title */}
        <div className="align-items-center">
          <h2>{page.title}</h2>
        </div>
        {/* end::Page Title */}

        {/* begin::Actions */}
        <div className="d-inline-flex align-items-center">
          <form onSubmit={handleSave} className="me-8">
            <a
              aria-disabled
              className={`btn btn-active-light-info`}
              onClick={() => handleGenerateSitemap(loading, setLoading)}
            >
              Generate Sitemap
            </a>
            {page.status === PageStatusType.DRAFT && (
              <button
                type={'button'}
                className="btn btn-active-light-warning"
                disabled={loading}
                onClick={handlePublish}
              >
                Publish
              </button>
            )}
            <a
              aria-disabled
              className={`btn btn-active-light-success`}
              href={
                parentPage
                  ? `${WEB_URL}/${parentPage.slug}/${page.slug}`
                  : `${WEB_URL}/${page.slug}`
              }
              target="_blank"
              rel="noreferrer"
            >
              Preview
            </a>
            <button
              type="submit"
              disabled={loading}
              className="btn btn-active-light-primary"
            >
              Save
            </button>
          </form>

          {/* begin::Toggle Sidebar */}
          {/* <button
						onClick={toggleSidebarDisplay}
						className="btn btn-icon btn-sm btn-white btn-active-primary"
						title="Toggle Sidebar"
					>
						{config.sidebar.display ? (
							<KTSVG
								path="/media/icons/duotone/Navigation/Right-2.svg"
								className="svg-icon-1 svg-icon-dark"
							/>
						) : (
							<KTSVG
								path="/media/icons/duotone/Navigation/Left-2.svg"
								className="svg-icon-1 svg-icon-dark"
							/>
						)}
					</button> */}
          {/* end::Toggle Sidebar */}
        </div>
        {/* end::Actions */}
      </div>

      {/* begin::Card */}
      <div className={`mt-3 card ${loading ? 'overlay overlay-block' : ''}`}>
        {/* begin::Card Body */}
        <div className={`card-body p-20 ${loading ? 'overlay-wrapper' : ''}`}>
          {/* begin::Element Drop Container */}
          <ElementDropContainer />

          {/* end::Element Drop Container */}

          {/* begin::Overlay Layer */}
          {loading && (
            <div className="overlay-layer rounded bg-dark bg-opacity-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
          {/* begin::Overlay Layer */}
        </div>
        {/* end::Card Body */}
      </div>
      {/* end::Card */}
    </>
  );
};
